import React from 'react';

function Footer() {
  return (
    <footer className="footer-wrapper footer-layout1">
    <div className="widget-area">
      <div className="container">
        <div className="row justify-content-between">
          <div className="col-md-6 col-xxl-3 col-xl-4">
            <div className="widget footer-widget">
              <h3 className="widget_title">About Company</h3>
              <div className="th-widget-about">
                <p className="about-text">
                  Where quality meets affordability. We understand the
                  importance of a smooth and enjoyable journey without the
                  burden of excessive costs. That's why we have meticulously
                  crafted our offerings to provide you with top-notch vehicles
                  at minimum expense.
                </p>
                <div className="th-social">
                  <a href="https://www.facebook.com/">
                    <i className="fab fa-facebook-f" />
                  </a>{" "}
                  <a href="https://www.twitter.com/">
                    <i className="fab fa-twitter" />
                  </a>{" "}
                  <a href="https://www.linkedin.com/">
                    <i className="fab fa-linkedin-in" />
                  </a>{" "}
                  <a href="https://www.whatsapp.com/">
                    <i className="fab fa-whatsapp" />
                  </a>{" "}
                  <a href="https://www.youtube.com/">
                    <i className="fab fa-youtube" />
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-6 col-xl-auto">
            <div className="widget widget_nav_menu footer-widget">
              <h3 className="widget_title">Quick Links</h3>
              <div className="menu-all-pages-container">
                <ul className="menu">
                  <li>
                    <a href="about.html">About Us</a>
                  </li>
                  <li>
                    <a href="team.html">Meet Our Team</a>
                  </li>
                  <li>
                    <a href="project.html">Our Projects</a>
                  </li>
                  <li>
                    <a href="faq.html">Help &amp; FAQs</a>
                  </li>
                  <li>
                    <a href="contact.html">Contact Us</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="col-md-6 col-xl-auto">
            <div className="widget widget_nav_menu footer-widget">
              <h3 className="widget_title">IT SERVICES</h3>
              <div className="menu-all-pages-container">
                <ul className="menu">
                  <li>
                    <a href="service-details.html">Web Development</a>
                  </li>
                  <li>
                    <a href="service-details.html">Business Development</a>
                  </li>
                  <li>
                    <a href="service-details.html">Product Management</a>
                  </li>
                  <li>
                    <a href="service-details.html">UI/UX Design</a>
                  </li>
                  <li>
                    <a href="service-details.html">Cloud services</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="col-md-6 col-xl-auto">
            <div className="widget footer-widget">
              <h3 className="widget_title">Recent Posts</h3>
              <div className="recent-post-wrap">
                <div className="recent-post">
                  <div className="media-img">
                    <a href="blog-details.html">
                      <img
                        src="assets/img/blog/recent-post-2-1.jpg"
                        alt="Blog Image"
                      />
                    </a>
                  </div>
                  <div className="media-body">
                    <h4 className="post-title">
                      <a className="text-inherit" href="blog-details.html">
                        Unsatiable entreaties may collecting Power.
                      </a>
                    </h4>
                    <div className="recent-post-meta">
                      <a href="blog.html">
                        <i className="fal fa-calendar-days" />
                        21 June, 2024
                      </a>
                    </div>
                  </div>
                </div>
                <div className="recent-post">
                  <div className="media-img">
                    <a href="blog-details.html">
                      <img
                        src="assets/img/blog/recent-post-2-2.jpg"
                        alt="Blog Image"
                      />
                    </a>
                  </div>
                  <div className="media-body">
                    <h4 className="post-title">
                      <a className="text-inherit" href="blog-details.html">
                        Regional Manager limited time management.
                      </a>
                    </h4>
                    <div className="recent-post-meta">
                      <a href="blog.html">
                        <i className="fal fa-calendar-days" />
                        22 June, 2024
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div className="copyright-wrap bg-title">
      <div className="container">
        <div className="row justify-content-between align-items-center">
          <div className="col-lg-6">
            <p className="copyright-text">
              Copyright <i className="fal fa-copyright" /> 2024{" "}
              <a href="https://themeforest.net/user/themeholy">Themeholy</a>.
              All Rights Reserved.
            </p>
          </div>
          <div className="col-lg-6 text-end d-none d-lg-block">
            <div className="footer-links">
              <ul>
                <li>
                  <a href="about.html">Terms &amp; Condition</a>
                </li>
                <li>
                  <a href="about.html">Careers</a>
                </li>
                <li>
                  <a href="about.html">Privacy Policy</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div className="shape-left">
      <img src="assets/img/shape/footer_shape_2.svg" alt="shape" />
    </div>
    <div className="shape-right">
      <div className="particle-1" id="particle-5" />
    </div>
  </footer>
  );
}

export default Footer;
